import { apiClient } from './client';

export interface Team {
  id: string;
  name: string;
  description: string | null;
  features: string[];
  memberIds: string[];
  memberCount: number;
}

export async function getTeams(): Promise<{ teams: Team[] }> {
  return apiClient.get('/teams');
}

export async function createTeam(data: {
  name: string;
  description?: string | null;
  features: string[];
  memberIds: string[];
}): Promise<{ teams: Team[] }> {
  return apiClient.post('/teams', data);
}

export async function updateTeam(
  id: string,
  data: { name?: string; description?: string | null; features?: string[]; memberIds?: string[] }
): Promise<{ teams: Team[] }> {
  return apiClient.patch(`/teams/${id}`, data);
}

export async function deleteTeam(id: string): Promise<{ success: boolean }> {
  return apiClient.delete(`/teams/${id}`);
}
